/**
 * ----------------------------------------------------------------------------------------------------------------------
 * GLOBAL ADD TO CART FUNCTION
 * ----------------------------------------------------------------------------------------------------------------------
 * 
 * A reusable utility function for adding one or more products to the Shopify cart via AJAX.
 * This function is designed to be used across different "Add to Cart" button implementations.
 * 
 * ----------------------------------------------------------------------------------------------------
 * Expected Input
 * ----------------------------------------------------------------------------------------------------
 * products - An array of product variant objects with the following structure:
 *   {
 *     variantId: Number | String,   // Required — the Shopify variant ID (not the product ID)
 *     quantity: Number              // Required — quantity to add (must be a positive integer)
 *     properties?: Object           // Optional — custom line item properties, if any
 *   }
 * 
* ----------------------------------------------------------------------------------------------------
 * Notes
 * ----------------------------------------------------------------------------------------------------
 * - Sends a POST request to Shopify's /cart/add.js endpoint.
 * - Supports line item customization via `properties`.
 * - Emits a `cart:refresh` event when complete (used for cart UI updates).
 * - Also exposed as `window.muAddToCart` for non-module scripts.   
 */


export async function muAddToCart(products) {
  try {
    const items = products.map(product => {
    const item = {
        id: product.variantId,
        quantity: product.quantity,
    };

    if (product.properties && typeof product.properties === 'object') {
        item.properties = product.properties;
    }

    return item;
    });

    await fetch(`/cart/add.js`, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    });
    const cart = document.querySelector('cart-drawer');
    cart.show();
  } catch (error) {
    console.error('Error adding products to cart:', error);
  } finally {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }
}

// Make it globally accessible for non-module scripts
window.muAddToCart = muAddToCart;
